import axios from "axios";
import config from "utils/config";
import { RentripsURL } from "./request";

type Config = {
	category?: string;
	action?: string;
	target?: string | number;
};

const logging = async (token: string, opt: Config) => {
	try {
		await axios.post(RentripsURL + "/api/etc/log", opt, config(token || ""));
	} catch (error) {
		console.error(error);
	}
};

export default logging;
